/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
document.addEventListener('variant:changed', function (event) {
  var variant = event.detail && event.detail.variant;

  if (!variant || typeof variant.price !== 'number') return;

  var origin = event.target;
  if (!(origin instanceof Element)) return;

  var scope = origin.closest('.shopify-section');
  if (!scope) return;

  var installment = scope.querySelector('.hm-installments strong');
  if (!installment) return;

  var amount = (variant.price / 100 / 12) * 1.2161;

  installment.textContent = '12x de ' + new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
});

(function () {
  if (window.hmGalleryInstalled) return;
  window.hmGalleryInstalled = true;

  var dialog;
  var photo;
  var counter;
  var previous;
  var next;
  var links = [];
  var index = 0;
  var opener;
  var touchStart;
  var oldOverflow;

  function createButton(text, label, css) {
    var button = document.createElement('button');
    button.type = 'button';
    button.textContent = text;
    button.setAttribute('aria-label', label);
    button.style.cssText = css;
    return button;
  }

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.setAttribute('aria-label', 'Fotos do produto');
  dialog.style.cssText =
  'position:fixed;inset:0;width:100%;max-width:none;' +
  'height:100%;max-height:none;margin:0;padding:0;' +
  'border:0;border-radius:0;background:transparent;' +
  'color:#fff;box-shadow:none;';

dialog.classList.add('hm-photo-dialog');

if (!document.getElementById('hm-photo-dialog-style')) {
  var dialogStyle = document.createElement('style');
  dialogStyle.id = 'hm-photo-dialog-style';
  dialogStyle.textContent =
    '.hm-photo-dialog::backdrop{background:rgba(0,0,0,.78);}';
  document.head.appendChild(dialogStyle);
}


    var layout = document.createElement('div');
    layout.style.cssText =
      'position:relative;display:flex;align-items:center;' +
      'justify-content:center;width:100%;height:100%;' +
      'padding:70px 52px;box-sizing:border-box;';

    photo = document.createElement('img');
    photo.style.cssText =
      'display:block;max-width:100%;max-height:100%;' +
      'width:auto;height:auto;object-fit:contain;';
    photo.draggable = false;

    var buttonStyle =
      'position:absolute;width:44px;height:44px;' +
      'padding:0;border:0;border-radius:50%;' +
'background:rgba(0,0,0,.35);color:#fff;font-size:32px;' +
      'line-height:1;cursor:pointer;';

    var close = createButton(
      '×',
      'Fechar fotos',
      buttonStyle + 'top:16px;right:16px;'
    );

    previous = createButton(
      '‹',
      'Foto anterior',
      buttonStyle + 'left:4px;top:calc(50% - 22px);'
    );

    next = createButton(
      '›',
      'Próxima foto',
      buttonStyle + 'right:4px;top:calc(50% - 22px);'
    );

    counter = document.createElement('div');
    counter.setAttribute('role', 'status');
    counter.setAttribute('aria-live', 'polite');
    counter.style.cssText =
      'position:absolute;bottom:20px;left:0;right:0;' +
      'text-align:center;font-size:16px;';

    layout.append(photo, close, previous, next, counter);
    dialog.appendChild(layout);
    layout.addEventListener('click', function (event) {
  if (event.target === layout) {
    dialog.close();
  }
});

    document.body.appendChild(dialog);

    close.addEventListener('click', function () {
      dialog.close();
    });

    previous.addEventListener('click', function () {
      showPhoto(index - 1);
    });

    next.addEventListener('click', function () {
      showPhoto(index + 1);
    });

    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showPhoto(index - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showPhoto(index + 1);
      }
    });

    layout.addEventListener('touchstart', function (event) {
      touchStart = event.touches.length === 1
        ? {
            x: event.touches[0].clientX,
            y: event.touches[0].clientY
          }
        : null;
    }, { passive: true });

    layout.addEventListener('touchend', function (event) {
      if (!touchStart || !event.changedTouches.length) return;

      var dx = event.changedTouches[0].clientX - touchStart.x;
      var dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;

      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
        showPhoto(index + (dx < 0 ? 1 : -1));
      }
    }, { passive: true });

    dialog.addEventListener('close', function () {
      document.body.style.overflow = oldOverflow;
      photo.removeAttribute('src');

      if (opener && opener.isConnected) {
        opener.focus({ preventScroll: true });
      }
    });
  }

  function showPhoto(position) {
    index = (position + links.length) % links.length;

    var source = links[index].querySelector('img');
    photo.src = links[index].href;
    photo.alt = source ? source.alt : '';

    counter.textContent = (index + 1) + ' / ' + links.length;
    previous.hidden = links.length < 2;
    next.hidden = links.length < 2;
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var link = event.target.closest('[data-hm-gallery-image]');
    if (!link || event.defaultPrevented) return;

    if (
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    if (
      !window.HTMLDialogElement ||
      typeof HTMLDialogElement.prototype.showModal !== 'function'
    ) return;

    var gallery = link.closest('.product-gallery');
    if (!gallery) return;

    links = Array.from(
      gallery.querySelectorAll('[data-hm-gallery-image]')
    ).filter(function (item) {
      return !item.closest('.is-filtered');
    });

    index = links.indexOf(link);
    if (index < 0) return;

    event.preventDefault();

    if (!dialog) buildDialog();

    opener = link;
    oldOverflow = document.body.style.overflow;
    showPhoto(index);
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  });
})();


(function () {
  function compactReviews() {
    document.querySelectorAll(
      '.product-item .jdgm-preview-badge'
    ).forEach(function (widget) {
      if (widget.dataset.hmCompact === 'true') return;

      var badge = widget.querySelector(
        '[data-average-rating][data-number-of-reviews]'
      );

      if (!badge) return;

      var rating = Number(badge.getAttribute('data-average-rating'));
      var count = Number(badge.getAttribute('data-number-of-reviews'));

      if (
        !Number.isFinite(rating) ||
        rating <= 0 ||
        rating > 5 ||
        !Number.isInteger(count) ||
        count < 1
      ) return;

      var compact = document.createElement('span');
      compact.style.cssText =
        'display:inline-flex;align-items:center;gap:4px;' +
        'font-size:14px;line-height:1.3;color:#555;';


      var star = document.createElement('span');
      star.textContent = '★';
      star.style.color = '#c9a208ff';
      star.setAttribute('aria-hidden', 'true');

      var numbers = document.createElement('span');
      numbers.textContent =
        rating.toFixed(1).replace('.', ',') + ' (' + count + ')';

      compact.setAttribute(
        'aria-label',
        'Nota ' + rating.toFixed(1).replace('.', ',') +
        ' de 5, com ' + count + ' avaliações'
      );

      compact.append(star, numbers);
      badge.replaceChildren(compact);
      widget.dataset.hmCompact = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', compactReviews);
  } else {
    compactReviews();
  }

  window.addEventListener('load', compactReviews);
  document.addEventListener('shopify:section:load', compactReviews);
})();

